<template>
  <div class="mv_excontract">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'电影台'},{name:'电影台续约'}]"></breadcrumb>
    <div class="mv_excontract-wrap">
      <div class="mv_excontract-contain">
        <mv-top-nav></mv-top-nav>
        <div class="mv_excontract-search_wrap">
          <div class="mv_excontract-search_top">
            <div class="mv_excontract-search_left">
              <el-select
                         @change="getList()"
                         v-model="plat">
                <el-option label="亚太六"
                           :value="6"></el-option>
                <el-option label="亚七"
                           :value="3"></el-option>
              </el-select>
              </div>
            <div class="mv_excontract-search_right">
              <a class="mv_excontract-table_download"
                  @click="exportExcel()" download="电影台续约列表.xls">
                <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                   :icon="['fas', 'level-up-alt']" />导出Excel
              </a>
            </div>
          </div>
        </div>
        <div class="mv_excontract-table-wrap">
          <div class="mv_excontract-table">
            <table>
              <tr>
                <th>
                  <el-checkbox v-model="checkAll"
                               @change="selectAll"></el-checkbox>
                </th>
                <th>单位</th>
                <th>省份</th>
                <th>房间</th>
                <th>卡号</th>
                <th>合同起日</th>
                <th>合同止日</th>
                <th>合同金额</th>
              </tr>
              <tr v-for="(item,index) in clientsList"
                  :key="item.clientId">
                <td>
                  <el-checkbox v-model="checkedList[index]"
                               @change="checkItem"></el-checkbox>
                </td>
                <td> <a @click="gotoDetail(item.clientId)">{{item.clientName}}</a></td>
                <td>{{item.areaName}}</td>
                <td>{{''}}</td>
                <td>{{item.clientCardno}}</td>
                <td>{{item.starttime.split('T')[0]}}</td>
                <td>{{item.stoptime.split('T')[0]}}</td>
                <td>{{item.contractmoney}}</td>
              </tr>
            </table>
          </div>
          <div class="mv_excontract-footer">
            <el-button @click="clientUpdateAudit()"
                       type="primary"
                       :disabled="buttonDisable"
                       class="ch_check-button">批量续约</el-button>
            <el-pagination @current-change="changePage"
                           :current-page="page"
                           class="mv_excontract-pagination"
                           background
                           layout="prev, pager, next"
                           :total="listSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import mvTopNav from '@/components/mvTopNav'
export default {
  components: {
    breadcrumb,
    mvTopNav
  },
  data() {
    return {
      downloadSrc: '',
      page: 0,
      listSize: 0,
      clientsList: [],
      checkAll: false,
      checkedList: [],
      buttonDisable: true,
      plat:6,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let params = {
        plat:this.plat,
        page: this.page,
        pageSize: 10
      }
      axios
        .post(api.movieAuditList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取电影台续约列表成功', res.data.result)
            this.clientsList = res.data.result.records
            this.checkAll = false
            for (let i in this.clientsList) {
              this.checkedList[i] = false
            }
            this.listSize = res.data.result.total
          } else {
            console.log('获取电影台续约列表失败', res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    selectAll(v) {
      if (v) {
        this.buttonDisable = false
        this.checkedList = this.checkedList.map(item => {
          return true
        })
      } else {
        this.buttonDisable = true
        this.checkedList = this.checkedList.map(item => {
          return false
        })
      }
    },
    changePage(v) {
      this.page = v
      this.getList()
    },
    //查看详情
    gotoDetail(id) {
      this.$router.push({ path: `/mv_channel/detail/${id}` })
    },
    checkItem(v) {
      if (v) {
        this.buttonDisable = false
      } else {
        let check = true
        for (let i of this.checkedList) {
          if (i === true) {
            check = false
            break
          }
        }
        this.buttonDisable = check
        if (this.checkAll) {
          this.checkAll = false
        }
      }
    },
    clientUpdateAudit() {
      let list = []
      for (let i in this.checkedList) {
        if (this.checkedList[i] === true) {
          list.push(this.clientsList[i].cpId)
        }
      }
      let params = {
        list: list
      }
      axios
        .post(api.movieUpdateAudit, params)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '批量续约成功',
              type: 'success'
            })
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //导出excel
    exportExcel() {
      let params ={ plat:this.plat}
     axios({ // 用axios发送post请求
            method: 'post',
            url: api.movieAuditExport,
            data:params,
            responseType: 'blob', // 表明返回服务器返回的数据类型
        })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '电影台审核列表.xls'
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.mv_excontract {
  .mv_excontract-wrap {
    padding: 77px 30px 0px 30px;
    .mv_excontract-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .mv_excontract-search_wrap {
        position: relative;
        .mv_excontract-search_top {
          background: #f8f8f8;
          padding: 20px 27px;
          display: flex;
          justify-content: flex-end;
          .mv_excontract-search_left {
            display: flex;
            flex: 1;
            .el-select {
              width: 120px;
              margin-right: 13px;
            }
          }
          .mv_excontract-search_right {
            display: flex;
            .mv_excontract-table_download {
              text-decoration: none;
              cursor: pointer;
              width: 108px;
              height: 38px;
              border-radius: 4px;
              background: #fff;
              margin-right: 10px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 38px;
              text-align: center;
            }
          }
        }
      }
      .mv_excontract-table-wrap {
        padding: 30px 30px 30px 30px;
        .mv_excontract-table_title {
          color: #9b9b9b;
          span {
            color: #f0722b;
          }
        }
        .mv_excontract-table {
          margin-top: 16px;
          min-height: 470px;
          tr {
            th {
              height: 40px;
              background: #5d5d5d;
              color: #fff;
            }
            td {
              text-align: center;
              height: 54px;

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .mv_excontract-footer {
          margin-top: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
}
</style>
